import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { LegalHoldsPage } from '../../../features/settings/legal-holds-page'

export const Route = createFileRoute('/_app/settings/legal-holds')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'legal-holds'),
  component: LegalHoldsPage,
})
